/**
 * External dependencies
 */
import React, { useState } from 'react';
import { Box, Text } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import Icon from 'components/icon';
import ButtonGroup from 'components/button-group';
import Button from 'components/button';
import { successNotice } from 'state/notices/actions';

/**
 * Style dependencies
 */
import './styles.scss';

const LocationSection = ({ location, edit, deleteLocation, ...props }) => {
    const [deleting, setDeleting] = useState(false);

    if (!location) {
        return null;
    }

    const onDeleteLocation = async () => {
        try {
            setDeleting(true);
            await deleteLocation(location.id);
            props.successNotice("Deleted");
        } catch (error) {}
        setDeleting(false);
    };

    return (
        <Card.Section key={location.id}>
            <Box display='flex' alignItems='center' justifyContent='spaceBetween'>
                <Box display='flex' alignItems='center'>
                    <Icon size='30' name='VscLocation' type='vsc' marginRight={25} />
                    <Box>
                        <Text weight='strong'>{location.name}</Text>
                        <Text size='small'>Location key {location.number}</Text>
                    </Box>
                </Box>
                <Box display='flex' alignItems='center'>
                    <ButtonGroup>
                        <Button onClick={() => edit(location.id)}>Edit</Button>
                        <Button disabled={deleting} onClick={onDeleteLocation}>
                            Delete
                        </Button>
                    </ButtonGroup>
                </Box>
            </Box>
        </Card.Section>
    );
};

export default connect(null, {
    successNotice
})(LocationSection);
